import { combineReducers } from "redux";
import { ACTION } from "./constants";

const initialState = { isLoading: false };

export default function KnowledgeStackReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION.MD_ARTICLE_LIST:
      return { ...state, mdArticleData: action.data, mdVideosData: undefined, mdInterviewArticleData: undefined };
    case ACTION.MD_APPEND_ARTICLE_LIST:
      return { ...state, mdArticleData: { ...state.mdArticleData, latestPosts: [...(state.mdArticleData?.latestPosts || []), ...action.data.latestPosts] }};
    case ACTION.MD_VIDEOS_LIST:
      return { ...state, mdVideosData: action.data, mdArticleData: undefined, mdInterviewArticleData: undefined };
    case ACTION.MD_APPEND_VIDEOS_LIST:
      return { ...state, mdVideosData: { ...state.mdVideosData, latestVideos: [...(state.mdVideosData?.latestVideos || []), ...action.data.latestVideos] }};
    case ACTION.MD_INTERVIEW_ARTICLE_LIST:
      return { ...state, mdInterviewArticleData: action.data, mdArticleData: undefined, mdVideosData: undefined };
    case ACTION.MD_APPEND_INTERVIEW_ARTICLE_LIST:
      return { ...state, mdInterviewArticleData: { ...state.mdInterviewArticleData, latestPosts: [...(state.mdInterviewArticleData?.latestPosts || []), ...action.data.latestPosts] }};
    case ACTION.MD_INTERVIEW_VIDEOS_LIST:
      return { ...state, mdInterviewVideosData: action.data };
    case ACTION.MD_DESK_MESSAGE:
      return { ...state, knowledgeStackMdPage: action.data };
    case ACTION.KNOWLEDGE_STACK_LISTING:
      return { ...state, knowledgeStackListingPage: action.data };
    case ACTION.TUESDAY_TALKING_POINTS:
      return { ...state, tuesdayTalkingPoints: action.data };
    case ACTION.MF_YEAR_BOOK:
      return { ...state, mfYearBookData: action.data };
    case ACTION.CHART_SCOPE:
      return { ...state, chartScopeData: action.data };
    case ACTION.GET_MF_INSIGHTS:
      return { ...state, mfInsightsData: action.data };  
    case ACTION.WEEKEND_BYTES:
      return { ...state, weekendBytesData: action.data };
    case ACTION.MARKET_REVIEW:
      return { ...state, marketReviewData: action.data };
    case ACTION.CREDIT_POLICY:
      return { ...state, creditPolicyData: action.data };
    case ACTION.KNOWLEDGE_STACK_MUSINGS:
      return { ...state, knowledgeStackMusingsData: action.data };
    case ACTION.KNOWLEDGE_SUBSCRIPTION:
      return { ...state, knowledgeSubscription: action.data };
    case ACTION.SUBMIT_MD_DESK_EMAIL:
      return { ...state, subscribeEmailResponse: action.data };
    case ACTION.KNOWLEDGE_PODCAST:
      return { ...state, podcastData: action.data };
    case ACTION.KNOWLEDGE_PODCAST_DETAIL:
      return { ...state, podcastDetailPageData: action.data };
    case ACTION.MEDIA_HOUSE_VIDEOS_LIST:
      return { ...state, mediaHouseVideosData: action.data };
    case ACTION.WEBINAR_LIST:
      return { ...state, webinarData: action.data };
    case ACTION.WEBINAR_DETAIL_PAGE:
      return { ...state, webDetailPageData: action.data };
    case ACTION.WEBINAR_REGISTRATION:
      return { ...state, webinarRegistration: action.data };
    case ACTION.SALES_HANDBOOK:
      return { ...state, handbookSalesData: action.data };
    case ACTION.BEHAVIOURAL_BLOGS:
      return { ...state, BehaviouralListData: action.data };  
    case ACTION.GET_MDSPEAK_VIDEO_DETAILS:
      return { ...state, mdspeakVideoDetail: action.data }; 
    case ACTION.GET_INTERVIEW_VIDEOS_DETAILS:
      return { ...state, interviewVideoDetail: action.data }; 
    default:
      return state;
  }
}
